var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.4 397.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 198.7,
    y1: 0,
    x2: 198.7,
    y2: 397.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3de2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5881fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c513ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.3,116.6l117.6,164.2h29.1l-117.6-164.2h-29.1ZM198.7,0h0C89,0,0,89,0,198.7h0c0,109.7,89,198.7,198.7,198.7h0c109.7,0,198.7-89,198.7-198.7h0C397.4,89,308.4,0,198.7,0ZM231.5,302.9l-51.4-71.9-67.2,71.9h-30.6l84.5-90.4-84.5-118h83.5l48.3,67.5,63.1-67.5h30.5l-80.4,86,87.7,122.4h-83.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.5b265408f9b6663c0fddccbc799091db.svg";
export { ForwardRef as ReactComponent };